// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__GK-3O","rootSmall":"AddTileButton_rootSmall__kzYps"};